<template>
  <v-container>
    <div>
      <!--    <v-container>-->
      <!--      <v-row>-->
      <!--        <h1>HAI</h1>-->
      <!--      </v-row>-->
      <!--      <v-row>-->
      <!--&lt;!&ndash;        <MealRate :meal="meal"/>&ndash;&gt;-->
      <!--      </v-row>-->
      <!--      <v-row>-->

      <!--      </v-row>-->
      <!--    </v-container>-->
      <div>
        <ChartComponent>
          <MealRate :meal="meal"/>
        </ChartComponent>
      </div>
    </div>
  </v-container>

</template>

<script>
import ChartComponent from '@/app/init.vue';
import MealRate from '@/components/partials/MealRate'
import MealService from '@/services/MealService';

export default {
  name: "Chart",
  components: {
    ChartComponent,
    MealRate
  },
  async mounted() {
    const mealId = this.$route.params.meal;
    const squid = this.$route.params.squid;
    if (squid) {
      const {data} = await MealService.getGraphicDataBySquid(squid);
      this.meal = data;
    } else {
      const author = ' ';
      const {data} = await MealService.getGraphic(mealId, author);
      this.meal = data;
    }
    console.log('meal', this.meal);
  },
  data() {
    return {
      meal: {},
    }
  }
};

</script>

<style scoped>

</style>
